<div class="card text-center">
    <div class="card-header">
        {{ 'CLOSEPATIENTVISIT' | translate }} /
        {{translate.currentLang == 'ar'? patVisit.fullnameAr : patVisit.fullnameEn}}
    </div>
    <div class="card-block">
        <div class="col-sm-4">
            <label for="formGroupExampleInput">{{ 'VisitStartDate' | translate }}</label>
            <input type="datetime" disabled [(ngModel)]="patVisit.startDate" />
        </div>
        <div class="col-sm-4">
            <label for="formGroupExampleInput">{{'VisitEndDate' | translate }}</label>
            <div class="input-group input-group-sm">
                <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" [(ngModel)]="patVisit.endDateNgb"
                    ngbDatepicker #endDate="ngbDatepicker">
                <div class="input-group-addon" (click)="endDate.toggle()">
                    <i class="fa fa-calendar"></i>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <label for="formGroupExampleInput">{{'TIMEVISITOUT' | translate }}</label>
            <ngb-timepicker [(ngModel)]="endTimeNgb"></ngb-timepicker>
        </div>
        <div class="col-sm-4">
            <sanabel-selectize appcode="37" (clicked)="patVisit.dischargeStatus=$event.code">
            </sanabel-selectize>
        </div>
        <div class="col-sm-12">
            <label for="notes">{{ 'NOTES' | translate }}</label>
            <textarea class="form-control" rows="4" id="notes" [(ngModel)]="patVisit.dischargeRemarks"
                name="dischargeRemarks"></textarea>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <btns-ctrl [appCodes]="[1]" (clicked)="onClicked($event)"></btns-ctrl>
                </div>
            </div>
        </div>
    </div>
</div>